(function () {
  function removeFixedPromo() {
    var phrases = ['get 10% off', 'join our forged community today'];
    var nodes = document.body ? document.body.querySelectorAll('div, aside, section, form') : [];
    nodes.forEach(function (el) {
      var text = (el.innerText || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text || !phrases.some(function (phrase) { return text.indexOf(phrase) !== -1; })) return;
      var style = window.getComputedStyle(el);
      if (style.position === 'fixed' || style.position === 'sticky') {
        el.remove();
      }
    });
  }

  function removeStrayHeadTagText() {
    if (!document.body) return;
    Array.prototype.slice.call(document.body.childNodes).forEach(function (node) {
      if (node.nodeType !== Node.TEXT_NODE) return;
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === 'tag:') node.remove();
    });
  }

  function clean() {
    document.querySelectorAll('.trust-badge-fixed').forEach(function (el) { el.remove(); });
    removeFixedPromo();
    removeStrayHeadTagText();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clean);
  } else {
    clean();
  }

  var observer = new MutationObserver(function () { window.requestAnimationFrame(clean); });
  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });
})();
